<template>
  <div class="row p-3">
    <div class="col-12 mb-4 ps-0">
      <h5 class="card-title">In welche Kategorie würden Sie Ihre Sehenswürdigkeit / Kultureinrichtung am ehesten
        einordnen?</h5>
    </div>
    <ErrorMessage name="kunst_kultur_kategorie" class="font-bold my-2"/>
    <Field type="radio" name="kunst_kultur_kategorie" v-model="surveyStore.data.kunst_kultur.kategorie">
      <template :key="radio.key" v-for="radio in surveyStore.currentConfig.currentStep.kunst_kultur_kategorie.radios">
        <div class="form-check col-12 col-lg-6">
          <input type="radio" v-model="surveyStore.data.kunst_kultur.kategorie" :value="radio.key" :id="radio.key"
                 class="form-check-input" :class="{'is-invalid': errors.kunst_kultur}"/>
          <label class="form-check-label" :for="radio.key">
            {{ radio.label }}
          </label>
        </div>
      </template>
    </Field>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field, ErrorMessage} from 'vee-validate';

export default {
  components: {
    Field,
    ErrorMessage
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},
  computed: {},

}
</script>
